// removed by extract-text-webpack-plugin
module.exports = {"Container":"PublicOffer__Container___6gWdD"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PublicOffer/PublicOffer.scss
// module id = 1412
// module chunks = 0